import { dayjsExt as dayjs } from '@orthly/runtime-utils';
import { OrthlyBrowserConfig } from '@orthly/ui';

export const LAB_SLIP_LAST_PRINTED_AT_PARAM_NAME: string = 'u';

export function getOrderQRCodeSrcUrl(orderId: string, utmSource: string = 'qr_code'): string {
    return `${OrthlyBrowserConfig.labPortalUrl}/orders/${orderId}?utm_source=${utmSource}&${LAB_SLIP_LAST_PRINTED_AT_PARAM_NAME}=${dayjs().unix()}`;
}
